import React, {useState} from 'react';
import Joi from 'joi';
import {AutocompleteSelect, AutoField} from 'components/forms/fields';

//import useFieldData from 'components/forms/hooks/useFieldData';
import {Grid, Typography} from '@material-ui/core';
import fields from 'components/forms/trainingcert/fields';
import {useGetSchoolsAll} from 'hooks';
import useGetCourseCodes from 'hooks/useGetCourseCodes';
import schemas from 'components/forms/fields/definedSchemas';
import {EndSection} from '..';
import {SiteUrls} from '../../../constants';

const schema = {
    school_name: Joi.object().messages({
        'object.base': 'Please select a school from the list.',
    }),
    course_name: Joi.object().messages({
        'object.base': 'Please select a course from the list.',
    }),
    course_number: Joi.object().messages({
        'object.base': 'Please select a code from the list.',
    }),
    issue_date: schemas.dateRequiredMaxToday.validation,
    been_used_before: Joi.string().messages({
        'string.empty': 'Select an option.',
    }),
};

const initialValues = {
    school_name: '',
    course_name: null,
    issue_date: '',
    been_used_before: '',
};

const sanitizeFunction = data => {
    const {
        //id_number_type,
        user_document_post_response,
        course_name,
        issue_date,
        been_used_before,
    } = data;

    return {
        course_id: course_name.id,
        issue_date,
        been_used_before,
        user_document_id: user_document_post_response?.user_document?.id,
    };
};

const TrainingCert = props => {
    const {data, isLoading: areSchoolsLoading} = useGetSchoolsAll();
    const schools = data?.schools;
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [, setSelectedCourse] = useState(null);
    const [userCourseInput, setUserCourseInput] = useState('');
    const {codes, isLoading: areCodesLoading} = useGetCourseCodes(
        userCourseInput,
        selectedSchool
    );

    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            endpointOverride='courses'
            redirectUrl={SiteUrls.TRAINING}
            sanitizeFunction={sanitizeFunction}
        >
            <Typography variant='h6' align='left'>
                Training Certificate Info
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        Let's enter the information about this Training
                        Certificate. Type in the boxes to search the options in
                        each field more quickly.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <AutocompleteSelect
                        required
                        name={fields.school_name.name}
                        label={fields.school_name.label}
                        options={schools || []}
                        loading={areSchoolsLoading}
                        getOptionLabel={option => option?.school_name}
                        onChangeListener={setSelectedSchool}
                        //onChange={updateProvider}
                    />
                </Grid>
                <Grid item xs={12}>
                    <AutocompleteSelect
                        required
                        name={fields.course_name.name}
                        label={fields.course_name.label}
                        getOptionLabel={option =>
                            `[${option?.course_number || 'None Available'}] ${
                                option?.course_name
                            }`
                        }
                        loading={areCodesLoading}
                        options={codes || []}
                        onChangeListener={setSelectedCourse}
                        onInputChange={e => {
                            setUserCourseInput(e?.target?.value);
                        }}
                        noOptionsText='No options, please enter at least 3 characters of the course name or number'
                    />
                </Grid>
                <Grid item xs={12}>
                    <AutoField field={fields.issue_date} name='issue_date' />
                </Grid>
                <Grid item xs={12}>
                    <AutoField
                        field={fields.been_used_before}
                        name='been_used_before'
                    />
                </Grid>
            </Grid>
        </EndSection>
    );
};

export default TrainingCert;
